// extracted by mini-css-extract-plugin
export default {"inputfield":"styles_inputfield__uDdE1","textArea":"styles_textArea__4FuA7"};